import { FC } from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../Header'
import Menu from '../Menu'

import './index.scss'

interface LayoutProps {
  children: React.ReactNode
  name: string
}

const Layout: FC<LayoutProps> = ({ children, name }) => {
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <main>
      <Header name={name} />
      <div className={`layout${isHome ? ' layout--no-sidebar' : ''}`}>
        {!isHome && <Menu />}
        {children}
      </div>
    </main>
  )
}

export default Layout
